<template>
  <section class="content-login">
    <div class="content-login-itens">
      <div class="content-login-itens-image">
        <div class="content-login-itens-image--bg"></div>
        <div class="content-login-itens-image--text">
          <h1>Seja bem vindo ao <span>Desenvolvimento Pessoal!</span></h1>
          <h2>Faça login para acessar <span>todos os recursos</span></h2>
        </div>
      </div>
      <div class="content-login-itens-form">
        <h2>ACESSAR</h2>
        <div class="content-login-btns">
          <a class="content-login-btns--google" @click="loginGoogle()">
            <img
              class="img-fluid"
              src="@/assets/img/logo-google.png"
              alt="logo google"
              title="logo google"
            />
            <p>Login com google</p>
          </a>
          <!-- <a class="content-login-btns--facebook" href="/">
            <img class="img-fluid" src="@/assets/img/logo-facebook.png" alt="logo facebook" title="logo facebook"/>
            <p>Login com facebook</p>
          </a> -->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";

export default {
  data() {
    return {};
  },
  methods: {
    loginGoogle() {
      this.$store.commit("SET_IS_LOADING", true);
      const auth = getAuth();
      const provider = new GoogleAuthProvider();
      signInWithPopup(auth, provider);
    },
  },
};
</script>

<style lang="scss">
.content-login {
  width: 100%;
  height: 100vh;
  &-itens {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    @media (max-width: 991px) {
      flex-direction: column;
    }
    &-image {
      width: calc(100% - 350px);
      height: 100%;
      position: relative;
      @media (max-width: 991px) {
        width: 100%;
      }
      &--bg {
        width: 100%;
        height: 100%;
        background: url("~@/assets/img/bg-login.png");
        background-repeat: no-repeat;
        background-position: center;
        &::after {
          content: "";
          display: block;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          background: rgba(0, 0, 0, 0.8);
          @media (max-width: 991px) {
            background: linear-gradient(
              to bottom,
              var(--orange-2),
              var(--yellow-2)
            );
          }
        }
      }
      &--text {
        position: absolute;
        top: 120px;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        padding: 0px 20px;
        @media (max-width: 991px) {
          top: 50%;
          transform: translate(-50%, -50%);
        }
        h1 {
          font-size: 48px;
          font-family: "Font Semibold";
          color: var(--white);
          margin-bottom: 120px;
          @media (min-width: 992px) and (max-width: 1199px) {
            font-size: 32px;
          }
          @media (max-width: 991px) {
            font-size: 24px;
            margin-bottom: 30px;
          }
          @media (max-width: 359px) {
            font-size: 20px;
          }
          span {
            display: block;
            color: var(--yellow);
          }
        }
        h2 {
          font-size: 36px;
          font-family: "Font Light";
          color: var(--white);
          margin-bottom: 0;
          @media (min-width: 992px) and (max-width: 1199px) {
            font-size: 24px;
          }
          @media (max-width: 991px) {
            font-size: 18px;
          }
          span {
            display: block;
          }
        }
      }
    }
    &-form {
      width: 350px;
      height: 100%;
      background: linear-gradient(to bottom, var(--orange-2), var(--yellow-2));
      padding-top: 120px;
      @media (max-width: 991px) {
        width: 100%;
        padding: 50px 0px;
        background: var(--white);
      }
      h2 {
        font-size: 24px;
        font-family: "Font Semibold";
        color: var(--white);
        margin-bottom: 25px;
        @media (max-width: 991px) {
          color: var(--black);
        }
      }
    }
  }
  &-btns {
    padding: 0px 20px;
    &--google,
    &--facebook {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      max-width: 300px;
      height: 60px;
      background: var(--white);
      border: 0;
      border-radius: 30px;
      padding: 0;
      margin: 0 auto;
      box-shadow: 0px 3px 16px rgba(0, 0, 0, 0.16);
      transition: 500ms;
      &:hover,
      &:focus {
        cursor: pointer;
        opacity: 0.8;
      }
      p {
        font-size: 20px;
        font-family: "Font Regular";
        color: var(--black);
        margin-left: 17px;
        min-width: 190px;
        text-align: left;
        margin-bottom: 0;
      }
    }
    &--facebook {
      margin-top: 20px;
    }
  }
}
</style>
